import { usePersistentStore } from "@/stores/persistent";
import { useListStore } from "@/stores/lists";

import { interactionFeedbackToast } from "@/functions/baseToast";

import { OFFLINE_ACTION } from "@/types/enum/general";

const handleOfflineAction = async (type: OFFLINE_ACTION, data: {
    locationId: string,
    listId: string,
    itemId: string,
    amount?: number,
    supplierItemId?: string,
    targetStock?: number
}): Promise<boolean> => {
    const persistentStore = usePersistentStore()
    const listStore = useListStore()

    if (type === OFFLINE_ACTION.ADD_ITEM) {
        listStore.isLoaded.listItems = false
        const existingItemDelete = persistentStore.offlineCache.deleteItem.findIndex(item => item.itemId === data.itemId)

        if (existingItemDelete >= 0) {
            persistentStore.offlineCache.deleteItem.splice(existingItemDelete, 1)
        }

        const existingItem = persistentStore.offlineCache.addItem.find(item => item.itemId === data.itemId)

        if (existingItem) {
            existingItem.amount = data.amount
            existingItem.targetStock = data.targetStock
        } else {
            persistentStore.offlineCache.addItem.push({
                locationId: data.locationId,
                listId: data.listId,
                itemId: data.itemId,
                amount: data.amount,
                targetStock: data.targetStock,
                supplierItemId: data.supplierItemId
            })
        }

        setTimeout(() => {
            interactionFeedbackToast(true, {
                type: 'addList',
                id: 'add-product-list'
            }, {
                cssClass: `toast-offset-70`
            }, true)
            listStore.isLoaded.listItems = true
        })
    } else if (type === OFFLINE_ACTION.DELETE_ITEM) {
        listStore.isLoaded.listItems = false
        //delete patchItem if existing
        const existingItemPatch = persistentStore.offlineCache.patchItem.findIndex(item => item.itemId === data.itemId)

        if (existingItemPatch >= 0) {
            persistentStore.offlineCache.patchItem.splice(existingItemPatch, 1)
        }
        //delete addItem if existing
        const existingItemAdd = persistentStore.offlineCache.addItem.findIndex(item => item.itemId === data.itemId)

        if (existingItemAdd >= 0) {
            persistentStore.offlineCache.addItem.splice(existingItemAdd, 1)
        }

        if (!data.itemId.startsWith('new')) {
            persistentStore.offlineCache.deleteItem.push({
                locationId: data.locationId,
                listId: data.listId,
                itemId: data.itemId
            })
        }

        setTimeout(() => {
            interactionFeedbackToast(
                true,
                {
                    id: 'delete-list',
                    type: 'delete',
                    target: 'product',
                },
                {
                    cssClass: 'toast-offset-80'
                }
            )
            listStore.isLoaded.listItems = true
        }, 100)

    } else if (type === OFFLINE_ACTION.PATCH_ITEM) {
        const existingItem = persistentStore.offlineCache.patchItem.find(item => item.itemId === data.itemId)

        if (existingItem) {
            existingItem.amount = data.amount
        } else {
            const existingItemAdd = persistentStore.offlineCache.addItem.find(item => item.itemId === data.itemId)

            if (existingItemAdd) {
                existingItemAdd.amount = data.amount
                existingItemAdd.targetStock = data.targetStock
            } else {
                persistentStore.offlineCache.patchItem.push({
                    locationId: data.locationId,
                    listId: data.listId,
                    itemId: data.itemId,
                    amount: data.amount,
                    targetStock: data.targetStock
                })
            }
        }
    }
    return true
}

export default handleOfflineAction
